/** Texts of questionnaires (docs/architecture/questionnaires.md). */
export const questionnairesDe = {
  title: 'Fragebögen',
  description:
    'Vorlagen für die Fragen an Datensätzen. Neue Datensätze übernehmen die Fragen einer Vorlage, bestehende behalten ihre.',
  empty: 'Noch keine Vorlage.',
  default: 'Standard',
  inactive: 'Inaktiv',
  questionCount_one: '{{count}} Frage',
  questionCount_other: '{{count}} Fragen',
  add: 'Neue Vorlage',
  loadDefaults: 'Standardinhalte übernehmen',
  defaultsLoaded_one: '{{count}} Vorlage übernommen',
  defaultsLoaded_other: '{{count}} Vorlagen übernommen',
  defaultsNone: 'Es gibt keine weiteren Standardvorlagen.',
  actions: 'Aktionen für „{{name}}“',
  edit: 'Bearbeiten',
  copy: 'Kopieren',
  makeDefault: 'Als Standard festlegen',
  delete: 'Löschen',
  moveUp: '„{{name}}“ nach oben',
  moveDown: '„{{name}}“ nach unten',
  name: 'Name',
  createTitle: 'Neue Vorlage',
  create: 'Anlegen',
  created: 'Vorlage angelegt',
  copyTitle: 'Vorlage kopieren',
  copyName: '{{name}} (Kopie)',
  copied: 'Vorlage kopiert',
  defaultSet: '„{{name}}“ ist jetzt die Standardvorlage',
  deleteTitle: '„{{name}}“ löschen?',
  deleteDescription:
    'Datensätze, die mit dieser Vorlage begonnen haben, behalten ihre Fragen und Antworten.',
  deleted: 'Vorlage gelöscht',
  errors: {
    'template-name-taken': 'Eine Vorlage mit diesem Namen gibt es schon.',
    'questionnaire-templates-limit': 'Mehr als 100 Vorlagen je Fragebogen gehen nicht.',
    'order-incomplete': 'Die Vorlagen haben sich inzwischen geändert. Bitte erneut sortieren.',
  },
  types: {
    text: 'Text',
    number: 'Zahl',
    'yes-no': 'Ja oder Nein',
    date: 'Datum',
    choice: 'Auswahl',
  },
  editor: {
    template: 'Vorlage',
    active: 'Aktiv',
    activeHint: 'Neue Datensätze bieten nur aktive Vorlagen an.',
    isDefault: 'Standardvorlage',
    isDefaultHint: 'Neue Datensätze beginnen mit dieser Vorlage.',
    questions: 'Fragen',
    questionsHint:
      'In dieser Reihenfolge erscheinen sie im Formular. Bestehende Datensätze behalten ihre Fragen.',
    noQuestions: 'Noch keine Frage.',
    question: 'Frage {{number}}',
    label: 'Frage',
    type: 'Art der Antwort',
    options: 'Auswahlmöglichkeiten',
    option: 'Auswahlmöglichkeit',
    addOption: 'Auswahlmöglichkeit hinzufügen',
    optionRow: 'Auswahlmöglichkeit {{number}}',
    removeOption: 'Auswahlmöglichkeit {{number}} entfernen',
    noOptions: 'Noch keine Auswahlmöglichkeit.',
    optionsRequired: 'Mindestens eine Auswahlmöglichkeit eintragen.',
    optionRepeats: '„{{option}}“ steht zweimal in der Liste.',
    preset: 'Vorgabe',
    presetHint: 'Steht in neuen Datensätzen schon als Antwort im Formular.',
    presetPlaceholders:
      'Steht in neuen Datensätzen schon als Antwort im Formular. Platzhalter füllt die STAW App aus dem Datensatz.',
    numberInvalid: 'Bitte eine Zahl eingeben.',
    insertPlaceholder: 'Platzhalter einfügen',
    help: 'Hilfetext',
    helpHint: 'Steht im Formular unter der Frage.',
    required: 'Pflichtfrage',
    addQuestion: 'Frage hinzufügen',
    removeQuestion: 'Frage {{number}} entfernen',
    moveUp: 'Frage {{number}} nach oben',
    moveDown: 'Frage {{number}} nach unten',
    invalid: 'Bitte die markierten Angaben prüfen.',
    unsaved: 'Ungespeicherte Änderungen',
    discard: 'Verwerfen',
    save: 'Speichern',
    saved: 'Vorlage gespeichert',
  },
  form: {
    none: 'Keine Angabe',
    yes: 'Ja',
    no: 'Nein',
    numberInvalid: 'Bitte eine Zahl eingeben.',
    empty: 'Noch keine Fragen',
    emptyHint: 'Eine Vorlage laden oder eigene Fragen ergänzen.',
    loadTemplate: 'Vorlage laden',
    noTemplates: 'Keine Vorlage verfügbar',
    templatesUnavailable: 'Ohne Verbindung liegen keine Vorlagen auf dem Gerät.',
    loaded_one: '{{count}} Frage ergänzt',
    loaded_other: '{{count}} Fragen ergänzt',
    nothingNew: 'Alle Fragen der Vorlage sind schon da.',
    addQuestion: 'Frage ergänzen',
    addTitle: 'Eigene Frage ergänzen',
    addDescription: 'Gilt nur für diesen Datensatz, die Vorlage bleibt, wie sie ist.',
    add: 'Ergänzen',
    own: 'Eigene Frage',
    removeQuestion: '„{{label}}“ entfernen',
    removeTitle: 'Frage „{{label}}“ entfernen?',
    removeDescription: 'Die Antwort wird mit entfernt.',
    removeTemplateDescription:
      'Die Antwort wird mit entfernt. Über „Vorlage laden“ lässt sich die Frage wieder ergänzen.',
    remove: 'Entfernen',
    answered: '{{answered}} von {{total}} beantwortet',
    template: 'Vorlage: {{name}}',
  },
  view: {
    unanswered: 'keine Angabe',
    empty: 'Keine Angaben.',
  },
  select: {
    placeholder: 'Vorlage wählen',
    loading: 'Vorlagen werden geladen …',
    none: 'Keine Vorlage verfügbar',
  },
};
